const types = {
    invoice: {
        name: 'Rechnung',
        icon: 'file-invoice'
    },
    order: {
        name: 'Bestellung',
        icon: 'shopping-cart'
    },
    customer: {
        name: 'Kunde',
        icon: 'user'
    },
    reservation: {
        name: 'Reservierung',
        icon: 'calendar'
    },
    voucher: {
        name: 'Gutschein',
        icon: 'gift'
    }
}

export function getIcon(type) {
    return type && types[type].icon
}

export function getTypeName(type) {
    return types[type].name
}
